exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper {\n  display: table;\n  height: 80px;\n  width: 100%; }\n  .wrapper .inner {\n    display: table-cell;\n    vertical-align: middle;\n    transition: background-color .1s, color .1s;\n    font-weight: normal;\n    font-size: 11px;\n    color: #BABBC7;\n    padding: 0 5px;\n    position: relative; }\n    .wrapper .inner:not(.active) {\n      cursor: pointer; }\n      .wrapper .inner:not(.active):hover {\n        background-color: #3641a8;\n        color: white; }\n      .wrapper .inner:not(.active):active {\n        background-color: #20297e; }\n    .wrapper .inner.active {\n      background-color: #515dd0;\n      color: white;\n      border-bottom: 1px solid #737eff; }\n    .wrapper .inner .icon {\n      font-size: 24px;\n      margin-bottom: -2px; }\n    .wrapper .inner .new-content-indicator {\n      background-color: #e22d43;\n      height: 6px;\n      width: 6px;\n      position: absolute;\n      border-radius: 3px;\n      top: 20px;\n      left: 12px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/left-nav/left-nav-item.scss
// module id = ../../../../../src/app/shared/components/left-nav/left-nav-item.scss
// module chunks = 12